import { Component, Input, OnChanges } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import {
  ChampagneBasicWineType,
  ChampagneFermentationType,
  ChampagneNature,
  FlavorType,
} from 'src/app/products/interfaces/models';
import { SubformBaseComponent } from 'src/app/shared/components/subform-base/subform-base.component';

import { ChampagneProperties } from '@app/api/marketplace/models';
import { ChampagneColor } from '@products/interfaces/champagne-color';
import { OfjType } from '@products/interfaces/ofj-type';

import { OemType } from './../../../../interfaces/oem-type';
import { QualityType } from './../../../../interfaces/quality-type';

@Component({
  selector: 'app-champagne-properties-subform',
  templateUrl: './champagne-properties-subform.component.html',
  styleUrls: ['./champagne-properties-subform.component.scss'],
})
export class ChampagnePropertiesSubformComponent
  extends SubformBaseComponent
  implements OnChanges
{
  DICT_PATH = 'PRODUCTS.CHAMPAGNE_PROPERTIES';

  @Input() isAlcoholFree!: boolean;

  champagneNature = ChampagneNature;
  champagneFermentationType = ChampagneFermentationType;
  champagneBasicWineType = ChampagneBasicWineType;
  qualityType = QualityType;
  oemType = OemType;
  ofjType = OfjType;
  champagneColor = ChampagneColor;
  childrenChampagneflavors = FlavorType;

  static buildForm(fb: FormBuilder, data?: ChampagneProperties) {
    return fb.group({
      qualityType: [data?.qualityType, [Validators.required]],
      ...(data?.oemType && { oemType: [data?.oemType, [Validators.required]] }),
      ...(data?.ofjType && { ofjType: [data?.ofjType, [Validators.required]] }),
      champagneColor: [data?.champagneColor, [Validators.required]],
      ...(data?.childrenChampagne && {
        childrenChampagne: [data?.childrenChampagne],
      }),
      ...(data?.childrenChampagneflavors && {
        childrenChampagneflavors: [
          data?.childrenChampagneflavors,
          [Validators.required],
        ],
      }),
      year: [
        data?.year,
        [Validators.min(1980), Validators.max(new Date().getFullYear())],
      ],
      nature: [data?.nature, [Validators.required]],
      ...(!data?.childrenChampagne && {
        fermentationType: [data?.fermentationType, [Validators.required]],
      }),
      ...(!data?.childrenChampagne && {
        basicWineType: [data?.basicWineType, [Validators.required]],
      }),
      flavored: [data?.flavored],
    });
  }

  ngOnChanges() {
    if (this.group) {
      if (this.isAlcoholFree) {
        this.group.addControl('childrenChampagne', this.fb.control(null));
      } else {
        this.group.removeControl('childrenChampagne');
        this.onChildrenChampagneChange(false);
      }
    }
  }

  onChildrenChampagneChange(event: boolean) {
    if (event) {
      this.group.addControl('childrenChampagneflavors', this.fb.control(null));
      this.group
        .get('childrenChampagneflavors')
        ?.addValidators(Validators.required);
      this.group.removeControl('fermentationType');
      this.group.removeControl('basicWineType');
    } else {
      this.group.removeControl('childrenChampagneflavors');
      this.group.addControl('fermentationType', this.fb.control(null));
      this.group.get('fermentationType')?.addValidators(Validators.required);
      this.group.addControl('basicWineType', this.fb.control(null));
      this.group.get('basicWineType')?.addValidators(Validators.required);
    }
  }

  onQualityTypeChange(event: QualityType) {
    switch (event) {
      case QualityType.withProtectedDesignationOfOriginOem: {
        this.group.addControl('oemType', this.fb.control(null));
        this.group.get('oemType')?.addValidators(Validators.required);
        this.group.removeControl('ofjType');
        break;
      }
      case QualityType.withProtectedGeographicalIndicationOfj: {
        this.group.addControl('ofjType', this.fb.control(null));
        this.group.get('ofjType')?.addValidators(Validators.required);
        this.group.removeControl('oemType');
        break;
      }
      case QualityType.other: {
        this.group.removeControl('oemType');
        this.group.removeControl('ofjType');
        break;
      }
    }
  }

  get currentYear() {
    return new Date().getFullYear();
  }
}
